import React from 'react'
import { TwitterShareButton } from 'react-share'
import styled from 'styled-components'
import { ShareButtonProps } from './types'
import { TwitterIcon } from '../../Svg'

const StyledIcon = styled(TwitterIcon)`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.gray6};
`

const TwitterShare: React.FC<ShareButtonProps> = ({ url, title }) => {
  return (
    <TwitterShareButton url={url} title={title}>
      <StyledIcon />
    </TwitterShareButton>
  )
}

export default TwitterShare
